// Fuentes de datos para el gráfico de impacto digital

export interface DigitalImpactSource {
  name: string; // Nombre de la fuente
  url: string; // URL de la fuente
  year: string; // Año de publicación
  organization: string; // Organización que publicó el estudio
  description: string; // Breve descripción del estudio
}

export const digitalImpactSources: DigitalImpactSource[] = [
  {
    name: 'Informe de Marketing Digital 2023',
    url: 'https://www.hubspot.com/marketing-statistics',
    year: '2023',
    organization: 'HubSpot',
    description:
      'Estadísticas actualizadas sobre el impacto del marketing digital en empresas de diferentes tamaños.',
  },
  {
    name: 'Estudio Global de Presencia Digital',
    url: 'https://www.statista.com/topics/1336/online-advertising/',
    year: '2023',
    organization: 'Statista',
    description:
      'Análisis comparativo del rendimiento empresarial con y sin estrategias digitales efectivas.',
  },
  {
    name: 'Reporte de Transformación Digital',
    url: 'https://www.mckinsey.com/capabilities/strategy-and-corporate-finance/our-insights/how-covid-19-has-pushed-companies-over-the-technology-tipping-point-and-transformed-business-forever',
    year: '2023',
    organization: 'McKinsey & Company',
    description:
      'Estudio sobre el impacto de la transformación digital en la rentabilidad y crecimiento empresarial.',
  },
  {
    name: 'Análisis de Conversión Digital',
    url: 'https://www.forrester.com/report/research-digital-transformation',
    year: '2023',
    organization: 'Forrester Research',
    description:
      'Investigación sobre tasas de conversión y retención de clientes en entornos digitales vs. tradicionales.',
  },
  {
    name: 'Tendencias de Visibilidad Online',
    url: 'https://www.gartner.com/en/marketing/research/digital-investment-trends',
    year: '2023',
    organization: 'Gartner',
    description:
      'Estudio sobre el impacto de la presencia digital en la visibilidad de marca y reconocimiento.',
  },
];

// Mapeo de métricas a fuentes específicas
export const metricToSourceMap: Record<string, number[]> = {
  Ventas: [0, 2], // Índices de las fuentes relevantes para Ventas
  Clientes: [0, 1, 3], // Índices para Clientes
  Visibilidad: [1, 4], // Índices para Visibilidad
  Retención: [2, 3], // Índices para Retención
  Conversión: [0, 3], // Índices para Conversión
};
